export const salesCrmTabKeys = [
  "dashboard",
  "meetings",
  "agent",
  "templates",
  "call-analysis",
  "sellers",
  "blacklist",
  "settlements",
] as const;

export type SalesCrmTabKey = (typeof salesCrmTabKeys)[number];

export const isSalesCrmTabKey = (key: string): key is SalesCrmTabKey => salesCrmTabKeys.includes(key as SalesCrmTabKey);
